import { useSnapshot } from "valtio"
import { configStore } from "../state/CommonState"
import ListEnquiry from "../enquiry/list-enquiry";
import HomeMain from "../enquiry/home-main";

export const EnquiriesPage = ()=>{
    const configurationStore = useSnapshot(configStore);
    return configurationStore.showQoute ? <HomeMain /> : <ListEnquiry/>
}